/**
  * @typedef {Object} Breakpoint
  * @param {number} min
  * @param {number} max
  * @param {string} name
  * @param {number} order
  */

/** @enum {Breakpoint} */
export const Breakpoints = {
  xs: { min:   0, max: 480, name: 'xs', order: 1 }, // Extra small devices (portrait phones, less than 481px)
  sm: { min: 481, max: 809, name: 'sm', order: 2 } , // Small devices (landscape phones, 481px and up)
  md: { min: 810, max: 1024, name: 'md', order: 3 }, // Medium devices (tablets, 810px and up)
  lg: { min: 1025, max: 1439, name: 'lg', order: 4 }, // Large devices (desktops, 1025px and up)
  xl: { min: 1440, max: Number.POSITIVE_INFINITY, name: 'xl', order: 5 }, // Extra large devices (large desktops, 1440px and up)
};
